import { render } from "./ModalConsentPolicyComponent.vue?vue&type=template&id=9914ba9c&scoped=true"
import script from "./ModalConsentPolicyComponent.vue?vue&type=script&lang=js"
export * from "./ModalConsentPolicyComponent.vue?vue&type=script&lang=js"

import "./ModalConsentPolicyComponent.vue?vue&type=style&index=0&id=9914ba9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9914ba9c"]])

export default __exports__